<ng-container *ngIf="workflow">
	<nz-page-header *ngIf="workflow.payload.id > 0" nzTitle="Edit Workflow" [nzSubtitle]="workflow._name"></nz-page-header>
	<nz-page-header *ngIf="workflow.payload.id <= 0" nzTitle="Create Workflow"></nz-page-header>

	<form [formGroup]="workflow.form">
		<div class="row g-4">
			<div class="col">
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="name" class="me-3"></app-invalid-form-indicator>
						Name
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<input nz-input formControlName="name" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="label" class="me-3"></app-invalid-form-indicator>
						Label
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<input nz-input formControlName="label" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="description" class="me-3"></app-invalid-form-indicator>
						Description
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<textarea nz-input formControlName="description" rows="3"></textarea>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="referencePrefix" class="me-3"></app-invalid-form-indicator>
						Reference Prefix
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<input nz-input formControlName="referencePrefix" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="ticketMode" class="me-3"></app-invalid-form-indicator>
						Ticket Mode
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<nz-select nzMode="default" nzPlaceHolder="Select statuses" formControlName="ticketMode" *ngIf="!workflow || !workflow.payload.id">
							<nz-option nzLabel="Claim" nzValue="Claim"/>
							<nz-option nzLabel="Complaint" nzValue="Complaint"/>
						</nz-select>
						<span *ngIf="workflow && workflow.payload.id">{{workflow.payload.ticketMode}}</span>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="linkToOtherTicketEnabled" class="me-3"></app-invalid-form-indicator>
						Can link to another ticket
					</nz-form-label>
					<nz-form-control [nzSpan]="18"  class="orange-checkbox">
						<label nz-checkbox formControlName="linkToOtherTicketEnabled">Enabled</label>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="autoAssign" class="me-3"></app-invalid-form-indicator>
						Auto Assign
					</nz-form-label>
					<nz-form-control [nzSpan]="18"  class="orange-checkbox">
						<label nz-checkbox formControlName="autoAssign">Enabled</label>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="linkMemberships" class="me-3"></app-invalid-form-indicator>
						Link Memberships
					</nz-form-label>
					<nz-form-control [nzSpan]="18"  class="orange-checkbox">
						<label nz-checkbox formControlName="linkMemberships">Enabled</label>
					</nz-form-control>
				</nz-form-item>
			</div>
			<div class="col">
			</div>
		</div>
		<h4 class="mt-3">Steps</h4>
		<button nz-button nzType="dashed" class="mb-1 me-1" (click)="addStep()">+ Add Step</button>
		<nz-steps nzDirection="horizontal" nzLabelPlacement="vertical" (nzIndexChange)="selectedStepIndex=$event" [nzCurrent]="selectedStepIndex">
			<nz-step *ngFor="let step of workflow.steps"
				[nzTitle]="stepLabel"
				[nzSubtitle]="stepLabel"
				[nzStatus]="step.formGroup.valid ? 'process' : 'error'" >
				<ng-template #stepLabel>
					<b *ngIf="step.payload.id==getActiveStep().payload.id" >{{step._label}}</b>
					<span *ngIf="step.payload.id!=getActiveStep().payload.id" >{{step._label}}</span>
				</ng-template>
			</nz-step>
		</nz-steps>
		<app-workflow-form-step *ngIf="workflow.steps.length != 0" [input]="getActiveStep()"></app-workflow-form-step>
		<!-- <nz-tabset [(nzSelectedIndex)]="selectedTabIndex" nzType="editable-card" (nzAdd)="addStep()" (nzClose)="removeStep($event)">
			<nz-tab *ngFor="let step of workflow.steps" [nzTitle]="titleTemplate" nzClosable>
				<ng-template #titleTemplate>
					<app-invalid-form-indicator [form]="step.formGroup"></app-invalid-form-indicator>
					{{ step._name }}
				</ng-template>
				<div class="tab-card-body">
					<app-workflow-form-step [input]="step"></app-workflow-form-step>
				</div>
			</nz-tab>
		</nz-tabset> -->
		<div class="mt-3">
			<button class="me-1" nz-button nzType="default" (click)="doCancel()">Cancel</button>
			<button
				nz-button
				nzType="default"
				(click)="saveAsDraft()" >
				Save as Draft
			</button>

			<button type="submit" nz-button nzType="primary" *ngIf="workflow.form.valid" (click)="doSave()">Save Workflow</button>
			<button
				*ngIf="!workflow.form.valid"
				nz-button
				nzType="default"
				nz-tooltip
				[nzTooltipTitle]="titleTemplate"
				(click)="touchAllFields()" >
				Save
			</button>
		</div>
	</form>


    <ng-template #titleTemplate let-thing>
		<ul>
			<li *ngFor="let item of getInvalidControlsList()">
				<b>{{item.field}}: </b>
				{{item. errors}}
			</li>
		</ul>
    </ng-template>
</ng-container>
